// import React from "react";
// import { Grid } from "@mui/material";
// import FormTextField from "../FormTextField";
// import FormRadioGroup from "../FormRadioGroup";

// const DriverInformationStep = ({ data, onChange, showErrors }) => {
//   console.log('data: ', data);
//   const getError = (field) =>
//     showErrors && !String(data[field] || "").trim()
//       ? "This field is required"
//       : "";

//   return (
//     <Grid container spacing={2.5}>
//       <Grid item xs={12} sm={6}>
//         <FormTextField
//           label="Driver Name"
//           required
//           value={data.driverName}
//           onChange={(value) => onChange("driverName", value)}
//           error={getError("driverName")}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <FormTextField
//           label="Phone Number"
//           required
//           value={data.phoneNumber}
//           onChange={(value) => onChange("phoneNumber", value)}
//           error={getError("phoneNumber")}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <FormTextField
//           label="Age"
//           required
//           type="number"
//           value={data.age}
//           onChange={(value) => onChange("age", value)}
//           error={getError("age")}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <FormTextField
//           label="E-Vehicle Number"
//           value={data.eVehicleNumber}
//           onChange={(value) => onChange("eVehicleNumber", value)}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <FormTextField
//           label="City"
//           required
//           value={data.city}
//           onChange={(value) => onChange("city", value)}
//           error={getError("city")}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <FormTextField
//           label="Location"
//           value={data.location}
//           onChange={(value) => onChange("location", value)}
//         />
//       </Grid>

//       <Grid item xs={12}>
//         <FormTextField
//           label="Address"
//           required
//           value={data.address}
//           onChange={(value) => onChange("address", value)}
//           error={getError("address")}
//           multiline
//           rows={2}
//         />
//       </Grid>

//       <Grid item xs={12}>
//         <FormRadioGroup
//           label="Vehicle Financed?"
//           required
//           value={data.vehicleFinanced}
//           onChange={(value) => onChange("vehicleFinanced", value)}
//           options={["Yes", "No"]}
//           error={
//             showErrors && !data.vehicleFinanced ? "Please select an option" : ""
//           }
//         />
//       </Grid>

//       {data.vehicleFinanced === "Yes" && (
//         <>
//           <Grid item xs={12} sm={6}>
//             <FormTextField
//               label="Vehicle Financier Name"
//               required
//               value={data.financierName}
//               onChange={(value) => onChange("financierName", value)}
//               error={getError("financierName")}
//             />
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <FormTextField
//               label="Financier Phone Number"
//               required
//               value={data.financierPhoneNumber}
//               onChange={(value) => onChange("financierPhoneNumber", value)}
//               error={getError("financierPhoneNumber")}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <FormTextField
//               label="Financier Address"
//               required
//               value={data.financierAddress}
//               onChange={(value) => onChange("financierAddress", value)}
//               error={getError("financierAddress")}
//               multiline
//               rows={2}
//             />
//           </Grid>
//         </>
//       )}
//     </Grid>
//   );
// };

// export default DriverInformationStep;

import React from "react";
import { Grid } from "@mui/material";
import FormTextField from "../FormTextField";
import FormRadioGroup from "../FormRadioGroup";

const DriverInformationStep = ({ data, onChange, showErrors }) => {
  const getError = (field) =>
    showErrors && !String(data[field] || "").trim()
      ? "This field is required"
      : "";

  const getFinancierError = (field) =>
    showErrors && !String(data.vehicleFinancier?.[field] || "").trim()
      ? "This field is required"
      : "";

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6}>
        <FormTextField
          label="Driver Name"
          required
          value={data.driverName}
          onChange={(value) => onChange("driverName", value)}
          error={getError("driverName")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormTextField
          label="Age"
          required
          type="number"
          value={data.age}
          onChange={(value) => onChange("age", value)}
          error={getError("age")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormTextField
          label="Phone Number"
          required
          type="tel"
          maxLength={10}
          value={data.phoneNumber}
          onChange={(value) => onChange("phoneNumber", value)}
          error={getError("phoneNumber")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormTextField
          label="Alternate Phone Number"
          type="tel"
          maxLength={10}
          value={data.alternatePhoneNumber}
          onChange={(value) => onChange("alternatePhoneNumber", value)}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormTextField
          label="City"
          required
          value={data.city}
          onChange={(value) => onChange("city", value)}
          error={getError("city")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormTextField
          label="E-Vehicle Number"
          value={data.eVehicleNumber}
          onChange={(value) => onChange("eVehicleNumber", value)}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <FormTextField
          label="Location"
          value={data.location}
          onChange={(value) => onChange("location", value)}
        />
      </Grid>

      <Grid item xs={12}>
        <FormTextField
          label="Address"
          required
          value={data.address}
          onChange={(value) => onChange("address", value)}
          error={getError("address")}
          multiline
          rows={3}
        />
      </Grid>

      <Grid item xs={12}>
        <FormRadioGroup
          label="Vehicle Financed?"
          required
          value={data.vehicleFinanced}
          onChange={(value) => onChange("vehicleFinanced", value)}
          options={["Yes", "No"]}
          error={
            showErrors && !data.vehicleFinanced ? "Please select an option" : ""
          }
        />
      </Grid>

      {data.vehicleFinanced === "Yes" && (
        <>
          <Grid item xs={12} sm={6}>
            <FormTextField
              label="Vehicle Financier Name"
              required
              value={data.vehicleFinancier?.name || ""}
              onChange={(value) =>
                onChange("vehicleFinancier", {
                  ...data.vehicleFinancier,
                  name: value,
                })
              }
              error={getFinancierError("name")}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormTextField
              label="Financier Phone Number"
              required
              type="number"
              value={data.vehicleFinancier?.phoneNumber || ""}
              onChange={(value) =>
                onChange("vehicleFinancier", {
                  ...data.vehicleFinancier,
                  phoneNumber: value,
                })
              }
              error={getFinancierError("phoneNumber")}
            />
          </Grid>

          <Grid item xs={12}>
            <FormTextField
              label="Financier Address"
              required
              value={data.vehicleFinancier?.address || ""}
              onChange={(value) =>
                onChange("vehicleFinancier", {
                  ...data.vehicleFinancier,
                  address: value,
                })
              }
              error={getFinancierError("address")}
              multiline
              rows={2}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default DriverInformationStep;
